import React from 'react';
import memoize from 'memoize-one';
import { BasicActionBtns, ActiveDot } from '../../components';

const columns = memoize(clickHandler => [
  {
    name: 'SIGLA',
    selector: 'acronym',
    sortable: true,
    grow: '1'
  },
  {
    name: 'NOMBRE',
    selector: 'name',
    sortable: true,
    grow: '1'
  },
  {
    name: 'ACTIVO',
    selector: 'is_active',
    cell: item => <ActiveDot item={item} />,
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'ACCIONES',
    cell: item => <BasicActionBtns item={item} resource="BranchOffice" clickHandler={clickHandler} />,
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    grow: '1',
    minWidth: '123px'
  }
]);

export default columns;
